module.exports = __webpack_public_path__ + "static/media/microphone.28071400.png";